import * as THREE from 'three';
import { label } from '../scene/products';
import { inchesLabel } from './rules';

export function runMeasurements(width, height, widthIn, corner, side) {
  const group = new THREE.Group(), color = side === 'a' ? '#925b44' : '#386b78';
  group.add(new THREE.LineSegments(new THREE.BufferGeometry().setFromPoints([
    new THREE.Vector3(-width / 2, height + .2, 0), new THREE.Vector3(width / 2, height + .2, 0),
    ...[-width / 2, width / 2].flatMap(x => [new THREE.Vector3(x, height + .13, 0), new THREE.Vector3(x, height + .27, 0)]),
  ]), new THREE.LineBasicMaterial({ color })));
  const text = label(`${corner ? side.toUpperCase() + ' / ' : ''}${inchesLabel(widthIn)}`, Math.max(.6, width * .15), Math.max(.16, width * .035), { color, size: 90 });
  text.position.set(0, height + .42, 0); group.add(text);
  return group;
}